import { notEmpty } from '~/infra/utils';
export function draftToCommonWithId(draft, idOverride) {
    return {
        id: idOverride !== null && idOverride !== void 0 ? idOverride : draft.id(),
        coverLetter: draft.coverLetter(),
        extraClause: draft.extraClause(),
        requirePaymentMethod: draft.requirePaymentMethod(),
        allowManualPayments: draft.allowManualPayments(),
        isExistingCustomer: draft.isExistingCustomer(),
        customNotificationText: draft.customNotificationText(),
        services: draft.services(),
        serviceBundles: Array.isArray(draft.serviceBundles()) && draft.serviceBundles().length > 0 ? {
            bundles: draft.serviceBundles()
        } : undefined,
        netTerms: draft.netTerms(),
        legalTermsDocuments: draft.legalTermsDocuments().filter(notEmpty),
        coverCreditCardFees: draft.coverCreditCardFees(),
        amendmentsApprovalMethod: draft.amendmentsApprovalMethod(),
        invoicesApprovalMethod: draft.invoicesApprovalMethod(),
        requestAccountantAccess: draft.requestAccountantAccess(),
        introVideo: draft.introVideo(),
        expirationDate: draft.expirationDate(),
        templateVariableValues: draft.templateVariableValues(),
        customPages: draft.customPages()
    };
}
